export type BreakpointUnit = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type Breakpoints<T extends BreakpointUnit = BreakpointUnit> = Record<T, string>;

export const createMedia = <BP extends Partial<Breakpoints>>(theme: {
  breakpoints: BP;
}): MediaFn<BP> => ({
  up: (bp) => `@media (min-width: ${theme.breakpoints[bp as BreakpointUnit] as string})`,
  down: (bp) => `@media (max-width: ${theme.breakpoints[bp as BreakpointUnit] as string})`,
});

export type BreakpointFn<BP extends Partial<Breakpoints>> = (bp: keyof BP) => string;

export type MediaFn<BP extends Partial<Breakpoints>> = {
  up: BreakpointFn<BP>;
  down: BreakpointFn<BP>;
};
